import Map from "@commons/Map";
import { usePage } from "@hooks/usePage";
import { CircularProgress } from "@mui/material";
import { useGetCameraTrapsGeoJson } from "@services/device/cameraTrap/getGeoJson";
import { useEffect } from "react";
import { toast } from "react-toastify";
import type { CameraTrapGeoJsonProperties } from "@services/device/cameraTrap/getGeoJson/type";
import CameraTrapPopup from "./CameraTrapPopup";
import { usePermissions } from "@hooks/usePermissions";

function MapCameraTrap({ filters }: { filters: string }) {
  const { openModal } = usePage();
  const { can } = usePermissions();

  const { data, isLoading, error } = useGetCameraTrapsGeoJson(filters);

  useEffect(() => {
    if (error) {
      toast.error("Erro ao carregar as câmeras trap");
    }
  }, [error]);

  const canCreateCameraTrap = can("create", "cameraTraps");

  return (
    <div className="w-full h-[calc(100vh-12rem)] flex flex-col gap-6">
      <div className="flex-1 bg-white rounded-lg shadow-md p-4 min-h-0">
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <Map.Root>
              {canCreateCameraTrap && (
                <Map.Button onClick={() => openModal("newCameraTrap")}>
                  Nova Câmera Trap
                </Map.Button>
              )}
              <Map.Draw<CameraTrapGeoJsonProperties>
                geoJsonData={data}
                popupComponent={CameraTrapPopup}
                canCreate={canCreateCameraTrap}
                modalToOpen="newCameraTrap"
                coordinatesButtonLabel="Cadastrar Câmera"
              />
            </Map.Root>
          </>
        )}
      </div>
    </div>
  );
}
export default MapCameraTrap;
